import { motion } from "framer-motion";
import { useCollectionData } from "../hooks/useCollectionData";
import { useSectionVisibility } from "../hooks/useSectionVisibility";

const PRESS_FALLBACK = [
    "Bridestory",
    "Harper's Bazaar ID",
    "Vogue Indonesia",
    "The Bridestory",
    "Weddingku",
    "Femina",
    "Tatler ID",
    "ELLE Wedding",
];

export default function PressStrip() {
    const visibility = useSectionVisibility();
    const { data: pressItems } = useCollectionData(
        "press",
        PRESS_FALLBACK.map((p) => ({ name: p }))
    );

    if (!visibility.pressStrip) return null;

    // Extract names from fetched data (could be array of strings or objects)
    const pressNames = pressItems.map((p) =>
        typeof p === "string" ? p : p.name || p
    );

    return (
        <section
            data-testid="press-strip"
            className="relative bg-[#0a0908] border-t border-b border-[#d4af37]/10 py-10 overflow-hidden"
        >
            <p className="text-center text-[10px] tracking-[0.4em] uppercase text-[#a6a196] mb-6">
                Dipublikasikan dan dipercaya oleh
            </p>
            <div className="marquee-track">
                {[...Array(2)].map((_, j) => (
                    <div
                        key={j}
                        className="flex items-center gap-16 pr-16 whitespace-nowrap"
                    >
                        {pressNames.map((p, i) => (
                            <span
                                key={i}
                                className="font-display text-2xl sm:text-3xl text-[#fdfbf7]/40 hover:text-[#d4af37] transition-colors tracking-[0.1em]"
                            >
                                {p}
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </section>
    );
}
